<template>
  <vue-modal :active="active" type="small" @closed="$emit('closed')">
    <vue-filters @applied="$modal.close('customers-filters')">
      <h3 class="border-b border-gray-lighter pb-2 mb-4">Filtrer</h3>
      <div class="mb-8">
        <div class="flex items-center mb-2">
          <span class="w-1/3 mr-2">Type</span>
          <vue-filter param="type" :options="filterTypeOptions"/>
        </div>
      </div>
      <h3 class="border-b border-gray-lighter pb-2 mb-4">Trier</h3>
      <div>
        <div class="flex items-center">
          <span class="w-1/3 mr-2">Nom</span>
          <vue-filter param="sortName"/>
        </div>
      </div>
    </vue-filters>
  </vue-modal>
</template>

<script>
import modal from '../../mixins/modal';
import VueFilters from '../filters/Filters.vue';
import VueFilter from '../filters/Filter.vue';

export default {
  components: { VueFilters, VueFilter },

  mixins: [modal],

  computed: {
    filterTypeOptions() {
      return [
        { label: 'Société', value: 'company' },
        { label: 'Particulier', value: 'personal' },
      ];
    },
  },
};
</script>
